import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ui-wish.png'


const _withScopeId = n => (_pushScopeId("data-v-0ed2ca25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"display":"inline","height":"1.5em"},
    src: _imports_0
  }),
  /*#__PURE__*/_createTextVNode(" Wish History ")
], -1))
const _hoisted_3 = { class: "select-wish-type" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Wish Type:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " * You can check the wishes you made. Wish records are updated instantly after the wish is made. If there is no record yet, please check again later. The times displayed below are according to local time. ", -1))
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","align-items":"center","margin-bottom":"1rem","gap":"1rem"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Pity:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Item Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Item Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Wish Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Time Received")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "purple"
}
const _hoisted_10 = {
  key: 1,
  class: "gold"
}
const _hoisted_11 = {
  key: 1,
  class: "footer-buttons"
}
const _hoisted_12 = { class: "page-button-box page-number-indicator" }

import { ItemDatabase } from "@/state/Gacha";
import Inventory from "@/state/Inventory";
import { GachaState } from "@/types";
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import BookOverlay from "../overlays/BookOverlay.vue";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  props: {
    inventory: null,
    activeBannerStorage: null
  },
  emits: ["exit"],
  setup(__props: any, { emit }) {

const props = __props as { inventory: Inventory; activeBannerStorage: string }

const store = useStore();



const currentPage = ref(0);
const selectedWishType = ref(props.activeBannerStorage);
const MAX_PULLS_PER_PAGE = store.state.settings.unlimitedHistoryScroll
  ? 1000000000
  : 5;

const pulls = computed(() =>
  props.inventory.pullHistory
    .map((pull) => {
      return {
        item: ItemDatabase[pull.item],
        bannerStorage: pull.bannerStorage,
        description: pull.description,
        date: pull.date,
      };
    })
    .reverse()
);

const numPullPages = computed(() =>
  Math.ceil(
    pulls.value.filter((p) => p.bannerStorage === selectedWishType.value)
      .length / MAX_PULLS_PER_PAGE
  )
);

const wishTypes = computed(() => [
  ...new Set(props.inventory.pullHistory.map((p) => p.bannerStorage)),
]);
const gachaStates = computed(() => {
  let ob: Record<string, GachaState> = {};
  for (const id of wishTypes.value) {
    ob[id] = JSON.parse(localStorage.getItem(`gacha-${id}`) ?? "{}");
  }
  return ob;
});

const exit = () => emit("exit");

watch(selectedWishType, () => (currentPage.value = 0));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BookOverlay, { onExit: exit }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedWishType).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishTypes), (item) => {
              return (_openBlock(), _createElementBlock("option", { key: item }, _toDisplayString(item), 1))
            }), 128))
          ], 512), [
            [_vModelSelect, selectedWishType.value]
          ])
        ]),
        _hoisted_5,
        (_ctx.$store.state.settings.showBannerPity)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", {
                class: _normalizeClass({
            'pity-box': true,
            guaranteed: _unref(gachaStates)[selectedWishType.value].guaranteedFeatured4Star,
          }),
                style: {"--color":"#a153e1"}
              }, _toDisplayString(_unref(gachaStates)[selectedWishType.value].pityCounter4), 3),
              _createElementVNode("div", {
                class: _normalizeClass({
            'pity-box': true,
            guaranteed: _unref(gachaStates)[selectedWishType.value].guaranteedFeatured5Star,
          }),
                style: {"--color":"#bd6029"}
              }, _toDisplayString(_unref(gachaStates)[selectedWishType.value].pityCounter5), 3)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("table", null, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pulls)
            .filter((p) => p.bannerStorage === selectedWishType.value)
            .slice(
              currentPage.value * _unref(MAX_PULLS_PER_PAGE),
              currentPage.value * _unref(MAX_PULLS_PER_PAGE) + _unref(MAX_PULLS_PER_PAGE)
            ), (pull, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(pull.item.type), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass({
                  purple: pull.item.rarity === 4,
                  gold: pull.item.rarity === 5,
                })
                }, _toDisplayString(pull.item.name), 3),
                (pull.item.rarity === 4)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (4-Star) "))
                  : (pull.item.rarity === 5)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, " (5-Star) "))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(pull.description), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(dayjs)(pull.date).format("YYYY-MM-DD HH:mm:ss")), 1)
            ]))
          }), 128))
        ]),
        (!_ctx.$store.state.settings.unlimitedHistoryScroll)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(['page-button-box', { disabled: currentPage.value == 0 }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value = Math.max(currentPage.value - 1, 0)))
              }, " < ", 2),
              _createElementVNode("div", _hoisted_12, _toDisplayString(currentPage.value + 1), 1),
              _createElementVNode("div", {
                class: _normalizeClass([
            'page-button-box',
            { disabled: currentPage.value == _unref(numPullPages) },
          ]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (currentPage.value = Math.min(currentPage.value + 1, _unref(numPullPages))))
              }, " > ", 2)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})